module.exports = __webpack_public_path__ + "static/media/topIcoList.9791b31a.png";